module.exports = __webpack_public_path__ + "static/work_SpaceKart-9778f1a4230e024483a0125d3da93b9e.mp4";